import React from 'react';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import StyledCheckbox from 'src/components/BeaconV2Components/common/StyledCheckbox';
import Box from '@mui/material/Box';

export enum ProductGrowthQuadrant {
  Upgrade = 'Upgrade',
  Rationalize = 'Rationalize',
  Leverage = 'Leverage',
  Invest = 'Invest'
}

const QuadrantCheckbox = ({ label, ...rest }: { label: string } & React.ComponentProps<typeof StyledCheckbox>) => {
  return (
    <Box
      display="inline-flex"
      gap="8px"
      sx={{
        cursor: 'pointer'
      }}
    >
      <StyledCheckbox {...rest} />
      <Text
        sx={{ '-webkit-font-smoothing': 'auto' }}
        variant="body2"
        onClick={() => rest.onChange && rest.onChange(null, !rest.checked)}
      >
        {label}
      </Text>
    </Box>
  );
};

/**
 * Displays the quadrant section on the product growth matrix filter modal
 */
export function MatchTypeFilterSection({
  quadrants,
  selectedQuadrants,
  setQuadrants
}: {
  quadrants: { name: string; id: string }[];
  selectedQuadrants: string[];
  setQuadrants: React.Dispatch<React.SetStateAction<any[]>>;
}) {
  return (
    <Flex flexDirection="column" gap="md">
      <Text sx={{ '-webkit-font-smoothing': 'auto' }} variant="subtitle1">
        Match Type
      </Text>
      <Box display="grid" gridTemplateColumns="max-content max-content" rowGap="16px" columnGap="118px">
        {quadrants.map((quadrant) => (
          <QuadrantCheckbox
            iconProps={{ width: '14px', height: '14px' }}
            key={quadrant.id}
            label={quadrant.name}
            checked={selectedQuadrants.includes(quadrant.id)}
            onChange={(_, checked) => {
              if (checked) {
                setQuadrants([...selectedQuadrants, quadrant.id]);
              } else {
                setQuadrants(selectedQuadrants.filter((q) => q !== quadrant.id));
              }
            }}
          />
        ))}
      </Box>
    </Flex>
  );
}

/**
 * Displays the quadrant section on the product growth matrix filter modal
 */
export default function QuadrantFilterSection({
  quadrants,
  setQuadrants
}: {
  quadrants: ProductGrowthQuadrant[];
  setQuadrants: React.Dispatch<React.SetStateAction<ProductGrowthQuadrant[]>>;
}) {
  return (
    <Flex flexDirection="column" gap="md">
      <Text sx={{ '-webkit-font-smoothing': 'auto' }} variant="subtitle1">
        Quadrants
      </Text>
      <Box display="grid" gridTemplateColumns="max-content max-content" rowGap="16px" columnGap="85px">
        {[
          ProductGrowthQuadrant.Upgrade,
          ProductGrowthQuadrant.Leverage,
          ProductGrowthQuadrant.Rationalize,
          ProductGrowthQuadrant.Invest
        ].map((quadrant) => (
          <QuadrantCheckbox
            iconProps={{ width: '14px', height: '14px' }}
            key={quadrant}
            label={`${quadrant} Quadrant`}
            checked={quadrants.includes(quadrant)}
            onChange={(_, checked) => {
              if (checked) {
                setQuadrants([...quadrants, quadrant]);
              } else {
                setQuadrants(quadrants.filter((q) => q !== quadrant));
              }
            }}
          />
        ))}
      </Box>
    </Flex>
  );
}
